// Icon + color mapping for spending categories - shared so any chart in the
// app can render categories consistently (icons, colors) without each
// component reinventing the mapping.

const ICON_MAP = {
  groceries: '🍎',
  shops: '🛍️',
  shopping: '🛍️',
  'food and drink': '🍽️',
  'restaurants & bars': '🍽️',
  'bills and utilities': '💡',
  'gas & electric': '⚡',
  home: '🏠',
  mortgage: '🏠',
  rent: '🏠',
  'home improvement': '🔨',
  transportation: '🚗',
  'auto payment': '🚗',
  'auto maintenance': '🔧',
  gas: '⛽',
  'taxi & ride shares': '🚕',
  healthcare: '⚕️',
  medical: '💊',
  'personal care': '🧴',
  recreation: '🎉',
  entertainment: '🎬',
  'entertainment & recreation': '🎉',
  travel: '✈️',
  education: '🎓',
  'gifts and donations': '🎁',
  service: '🔧',
  tax: '🧾',
  phone: '📱',
  'internet & cable': '🌐',
  water: '💧',
  pets: '🐾',
  'coffee shops': '☕',
  payment: '💳',
  transfer: '🔄',
  other: '📦',
  uncategorized: '❓',
};

export const categoryIcon = (category) => ICON_MAP[(category || '').toLowerCase().trim()] || '💰';

// A vibrant, varied palette that cycles by row position - matches the
// "each bar gets its own color" look rather than a single accent color
export const CATEGORY_PALETTE = [
  '#00d4aa', '#38bdf8', '#fbbf24', '#f97316', '#a78bfa',
  '#38e0d0', '#ec4899', '#4f7fff', '#84cc16', '#00b8a0',
  '#f472b6', '#8b5cf6', '#fb923c', '#22d3ee', '#facc15',
  '#60a5fa', '#34d399', '#f87171', '#c084fc', '#fde047',
];

export const categoryColor = (index) => CATEGORY_PALETTE[index % CATEGORY_PALETTE.length];
